import { render, staticRenderFns } from "./YonetimDetay.vue?vue&type=template&id=0886499c&scoped=true&"
import script from "./YonetimDetay.vue?vue&type=script&lang=js&"
export * from "./YonetimDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0886499c",
  null
  
)

export default component.exports